var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "kr-embedded-method-display-wrapper",
      class: _vm.dynamicClasses,
    },
    [
      _c(
        "div",
        { ref: "methodDisplay", staticClass: "kr-embedded-method-display" },
        [
          _vm.method
            ? _c(
                "div",
                {
                  ref: "header",
                  staticClass: "kr-embedded-method-header",
                  on: {
                    click: function ($event) {
                      return _vm.setDefaultActiveMethod()
                    },
                  },
                },
                [
                  _c("BrandIcon", { attrs: { method: _vm.method } }),
                  _c("div", { staticClass: "kr-embedded-method-label" }, [
                    _vm._v(_vm._s(_vm.methodLabel)),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c("EmbeddedMethod", {
            attrs: { method: _vm.method, extraMargin: _vm.extraMargin },
            on: { height: _vm.updateHeight },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }